import React from 'react';
import styles from 'assets/css/SMARTGoalLauncher.module.css';
import { withCardLinkIconWrap } from 'Components/Card/CardLink';
import { IconAngleRight } from '@ace/react-icons';
import useSMARTGoalOverlay from 'context/SMARTGoalOverlayContext';
import buttonStyles from 'assets/css/Button.module.css';

const IconAngleRightWrap = withCardLinkIconWrap(IconAngleRight);

function SMARTGoalsLauncherCard(props) {
    const { TitleStateCopy, BodyStateCopy, CallToAction } = props.data;

    const { toggleSMARTGoalsOverlay } = useSMARTGoalOverlay();

    return (
        <div className={styles.sgLauncherContainer}>
            <div className={styles.sgLaunchContentWrapper}>
                {TitleStateCopy && TitleStateCopy.length && <h3 className={styles.sgLauncherTitleCopy}>{TitleStateCopy}</h3>}
                {BodyStateCopy && BodyStateCopy.length && <p className={styles.sgLauncherBodyCopy}>{BodyStateCopy}</p>}
                <div className={styles.sgLauncherBtnContainer}>
                    <span className={`${buttonStyles.primary} ${buttonStyles.primaryGreen} ${styles.sgLauncherBtn}`} style={{cursor: 'pointer'}} onClick={() => toggleSMARTGoalsOverlay()}>
                        {CallToAction}<IconAngleRightWrap />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default SMARTGoalsLauncherCard;